import jwtDecode from 'jwt-decode';

export async function setAccessToken(token, expired = 0) {
  localStorage.setItem(
    'adminSession.accessToken',
    JSON.stringify({ token, expired })
  );
}
// Google's refresh token stays on the server; drop any copy an older build
// stored here.
localStorage.removeItem('adminSession.refreshToken');

export async function setUser(user) {
  localStorage.setItem('adminSession.user', JSON.stringify(user));
}

// Staff session from the email code step after Google sign-in. The API wants
// it in X-Staff-Session next to the Google ID token (Authorization).
export const STAFF_SESSION_HEADER = 'X-Staff-Session';

export function setStaffSession(token, expiresAt) {
  localStorage.setItem(
    'adminSession.staffSession',
    JSON.stringify({ token, expiresAt })
  );
}

export function getStaffSession() {
  const raw = localStorage.getItem('adminSession.staffSession');
  if (!raw) return {};
  try {
    const session = JSON.parse(raw);
    if (session?.expiresAt && new Date(session.expiresAt) <= new Date()) {
      return {};
    }
    return session || {};
  } catch {
    return {};
  }
}

export function staffSessionHeaders() {
  const { token } = getStaffSession();
  return token ? { [STAFF_SESSION_HEADER]: token } : {};
}

export async function deleteToken() {
  localStorage.removeItem('adminSession.staffSession');
  localStorage.removeItem('adminSession.accessToken');
  localStorage.removeItem('adminSession.refreshToken');
  localStorage.removeItem('adminSession.user');
}

// Drops the Google ID token and user but keeps the staff session: signing in
// with Google again then skips the email code while the session lasts.
export function deleteGoogleToken() {
  localStorage.removeItem('adminSession.accessToken');
  localStorage.removeItem('adminSession.user');
}

export function hasStaffSession() {
  return !!getStaffSession().token;
}

// The Google ID token's own expiry (exp claim, seconds), or 0.
export function getAccessTokenExp() {
  const { token } = getAccessToken();
  if (!token) return 0;
  try {
    return jwtDecode(token).exp || 0;
  } catch {
    return 0;
  }
}

export function getAccessToken() {
  const tokenObject = localStorage.getItem('adminSession.accessToken');
  if (tokenObject) return JSON.parse(tokenObject);
  return {};
}

export function getUser() {
  const user = localStorage.getItem('adminSession.user');
  return JSON.parse(user);
}

export function parseOAuth(oauthObject) {
  if (oauthObject) {
    const { id_token, refresh_token, expires_in, ...props } = oauthObject;
    if (!id_token) {
      return {};
    }

    const user = jwtDecode(id_token);

    return {
      user,
      token: id_token,
      refreshToken: refresh_token,
      expiresIn: expires_in,
      props,
    };
  }

  return {};
}
